import React, { useContext } from "react";
import { Link } from "react-router-dom";
import UserContext from "../../userContext";
import "./Header.css";

const Header = () => {
  const [loggedInUser, setLoggedInUser] = useContext(UserContext);
  console.log(loggedInUser);
  return (
    <header>
      <div className="container">
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
          <div className="container-fluid">
            <Link className="navbar-brand" to="/">
              <span className="project-name">GRAB VEHICLES</span> 
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNavAltMarkup"
              aria-controls="navbarNavAltMarkup"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse justify-content-end"
              id="navbarNavAltMarkup"
            >
              <div className="navbar-nav global-nav">
                <Link className="nav-link" aria-current="page" to="/">
                  Home
                </Link>
                <Link className="nav-link" to={`/destination/1`}>
                  Destination
                </Link>
                <Link className="nav-link" to="/blog">
                  Blog
                </Link>
                <Link className="nav-link" to="/contact">
                  Contact
                </Link>
                {!loggedInUser.email && (
                  <Link className="btn btn-primary" to="/login">
                    Login
                  </Link>
                )}
                {loggedInUser.email && (
                  <Link className="nav-link" to="/profile">
                    {loggedInUser.name}
                  </Link>
                )}
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
